/**
 * BODA (Build Once Deploy Anywhere) Environment Sync
 * 
 * This module syncs runtime environment variables from window.process.env
 * (populated by config.js) to the webpack-shimmed process.env object.
 * 
 * This MUST be imported as the first module in the application entry point.
 */

// Only run in browser environment
if (typeof window !== 'undefined' && window.process && window.process.env) {
  // Copy all runtime config values to webpack's process.env shim
  Object.keys(window.process.env).forEach(function(key) {
    if (typeof process !== 'undefined' && process.env) {
      process.env[key] = window.process.env[key];
    }
  });
}



// WEBPACK FOOTER //
// ./src/boda-env-sync.js